export default __webpack_public_path__ + "static/media/yellowTheme-girl.641f7b0b.svg";